import { render } from "./Mobile.vue?vue&type=template&id=43446028&lang=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/Mobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43446028"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43446028', __exports__)) {
    api.reload('43446028', __exports__)
  }
  
  module.hot.accept("./Mobile.vue?vue&type=template&id=43446028&lang=true", () => {
    api.rerender('43446028', render)
  })

}


export default __exports__